export { FatSplitter } from './fat-splitter';
